import { Navigate, Outlet } from 'react-router';
import { useAppStateContext } from '../hooks';

// For device configuration (authenticated but not device-registered)
export const DeviceProtectedRoute = () => {
  const { appState } = useAppStateContext();

  const isValidatePlayer = Boolean(appState?.tid);
  const isDeviceRegistered =
    Boolean(appState?.deviceInfo?.accessToken) && isValidatePlayer;

  if (isDeviceRegistered) {
    return <Navigate to="/" replace />;
  }

  if (!isValidatePlayer) {
    return <Navigate to="/auth/login" replace />;
  }

  // Only allow device config routes
  return <Outlet />;
};
